import {
  FormControlLabel,
  Checkbox as MuiCheckbox,
  styled,
  type CheckboxProps,
} from '@mui/material';
import { forwardRef, ReactNode } from 'react';

type Props = CheckboxProps & {
  label?: ReactNode;
  labelPosition?: 'before' | 'after';
};

const StyledFormControlLabel = styled(FormControlLabel, {
  shouldForwardProp: (prop) => prop !== 'labelPosition',
})<{ labelPosition: 'before' | 'after' }>(({ theme, labelPosition }) => ({
  ...(labelPosition === 'before' && {
    gap: theme.spacing(theme.spacingSizes.sm),
  }),
}));

const labelVariantBySize: Record<
  NonNullable<CheckboxProps['size']>,
  'h6' | 'body2'
> = {
  medium: 'h6',
  small: 'body2',
  large: 'h6',
};

const Checkbox = forwardRef<HTMLButtonElement, Props>(
  ({ label, size = 'medium', labelPosition = 'after', ...props }, ref) => {
    if (
      label === undefined ||
      label === null ||
      label === '' ||
      label === false
    ) {
      return <MuiCheckbox ref={ref} size={size} {...props} />;
    }

    return (
      <StyledFormControlLabel
        label={label}
        labelPlacement={labelPosition === 'before' ? 'start' : 'end'}
        labelPosition={labelPosition}
        disabled={props.disabled}
        slotProps={{ typography: { variant: labelVariantBySize[size] } }}
        control={<MuiCheckbox ref={ref} size={size} {...props} />}
      />
    );
  },
);

Checkbox.displayName = 'Checkbox';

export default Checkbox;
